import { defineMessages } from 'react-intl-next';
var messages = defineMessages({
  emptyState: {
    id: 'jsm.attachment-field.shared-viewer.emptyState',
    defaultMessage: 'No attachments uploaded',
    description: 'Empty state message when no attachments uploaded'
  }
});
export default messages;